import { getApiRequest } from "../../../services/getApiRequest"

export function fetchPackageResult(culture, currency = "KWD") {
    let ApiRequest = getApiRequest();
    return ApiRequest({
        url: "Package/StaticSearch?currency=" + currency + "&culture=" + culture,
        method: "get",
    })
        .then(function (response) {
            if (response.status == "200" && response?.data?.data?.Data) {
                return response?.data?.data?.Data;
            } else {
                return false;
            }
        })
        .catch(function (error) {
            console.log(error);
            return false;
        });
}

export function fetchPackageCategory(culture, currency = "KWD") {
    let ApiRequest = getApiRequest();
    return ApiRequest({
        url: "Package/StaticPackageCategory?currency=" + currency + "&culture=" + culture,
        method: "get",
    })
        .then(function (response) {
            if (response.status == "200" && response?.data?.data?.Data) {
                return response?.data?.data?.Data;
            } else {
                return false;
            }
        })
        .catch(function (error) {
            console.log(error);
            return false;
        });
}

export function fetchPackageDetails(culture, currency = "KWD", packageKey) {
    let ApiRequest = getApiRequest();
    return ApiRequest({
        url: "Package/getStaticPackageDetails?currency=" + currency + "&culture=" + culture + "&packageKey=" + packageKey,
        method: "get",
    })
        .then(function (response) {
            if (response.status == "200" && response?.data?.data?.Data) {
                return response?.data?.data?.Data;
            } else {
                return false;
            }
        })
        .catch(function (error) {
            console.log(error);
            return false;
        });
}

export const submitPackageDetails = (requestBody, currency = "KWD", culture) => {
    const ApiRequest = getApiRequest();
  
    return ApiRequest({
      url: `Package/submitPackageDetails?currency=${currency}&culture=${culture}`,
      method: "post",
      data: requestBody,
    })
      .then((response) => {
        console.log("API Response:", response);
  
        if (response.status === 200 && response?.data?.data?.Data) {
          return response.data.data;
        } else {
          console.error("Unexpected response format or status:", response);
          return false;
        }
      })
      .catch((error) => {
        console.error("Error during API call:", error);
        return false;
      });
};
  